<template>
  <!-- 标题文字组件 -->
  <el-dialog :visible="headerPhoto" :show-close="false" top="35vh" class="phone-dialog" center title="联系电话">
    <div class="header-text">
      <p>
        <span>{{data.name}}</span>
        <a :href="'tel://'+data.desc"> {{data.desc}} </a>
      </p>
      <p>{{data.address}}</p>
    </div>
    <div class="colseText">
      <el-button @click="colseDialog" type="text" icon="el-icon-circle-close" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // 对话框状态
    headerPhoto: {
      type: Boolean,
      default: false
    },
    // 文本数据
    data: {
      type: Object,
      required: true
    }
  },

  methods: {
    // 关闭对话框事件
    colseDialog() {
      // 清空数据
      this.textDialog = {
        header: '',
        desc: []
      }
      this.$emit('update:headerPhoto', false)
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
</style>
